import { makeVar } from '@apollo/client'
import { OrderDirection } from '@appTypes/UtilTypes'
import { RockpoolItemFilter, RockpoolItemOrderBy } from '@appTypes/RockpoolTypes'

export const SuccessPoolModalVar = makeVar<boolean>(true)

export interface RockpoolFilter {
  type: RockpoolItemFilter
  sortingDirection: OrderDirection
  sortingField: RockpoolItemOrderBy
}

export const rockpoolFiltersVar = makeVar<RockpoolFilter>({
  type: RockpoolItemFilter.live,
  sortingDirection: OrderDirection.desc,
  sortingField: RockpoolItemOrderBy.timestamp
})
